export default __webpack_public_path__ + "static/media/milestone 900.11400537.svg";